import { useState } from "react";
import { Link } from "react-router-dom";
import FooterGuide from "@/pages/home/components/FooterGuide";

export default function Footer() {
  const [guideOpen, setGuideOpen] = useState(false);
  return (
    <footer className="bg-background-50 pt-16 pb-6 px-4 md:px-6">
      <div className="max-w-6xl mx-auto bg-foreground-950 rounded-3xl px-6 md:px-14 py-12 md:py-16 text-background-100">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <h3 className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-background-50">
              試合日をもっと、<br />
              <span className="italic">身軽に。</span>
            </h3>
            <p className="mt-4 text-background-200 text-sm leading-relaxed">
              シーズン開幕・限定日程・お得なキャンペーンをメールでご案内します。
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-background-300 text-xs uppercase tracking-widest">
              メニュー
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                { href: "#service", label: "サービス" },
                { href: "#feature", label: "特徴" },
                { href: "#plan", label: "料金プラン" },
                { href: "#faq", label: "よくある質問" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-background-50 underline underline-offset-4 hover:text-secondary-200 whitespace-nowrap cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  onClick={() => setGuideOpen((v) => !v)}
                  aria-expanded={guideOpen}
                  className="group flex items-center gap-1.5 text-background-50 underline underline-offset-4 hover:text-secondary-200 whitespace-nowrap cursor-pointer"
                >
                  ご利用案内
                  <i
                    className={`ri-arrow-down-s-line text-base transition-transform duration-300 ${guideOpen ? "rotate-180" : ""}`}
                  />
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-background-300 text-xs uppercase tracking-widest">
              連絡先
            </div>
            <div className="mt-5 space-y-2 text-sm">
              <a href="tel:0113753266" className="block text-background-50 hover:text-secondary-200 cursor-pointer">
                <i className="ri-phone-line mr-2" />
                ０１１－３７５－３２２６
              </a>
              <div className="text-background-100/60 text-xs mt-1">
                営業日：エスコンフィールド北海道の試合・イベント開催日
              </div>
            </div>

            <div className="mt-8 text-background-300 text-xs uppercase tracking-widest">
              所在地
            </div>
            <div className="mt-5 text-sm text-background-100 leading-relaxed">
              〒061-1102<br />
              北海道北広島市西の里301-2<br />
              有限会社アネザキカンパニー敷地内
            </div>
          </div>
        </div>

        <div
          className={`grid transition-all duration-500 ease-out ${
            guideOpen ? "grid-rows-[1fr] opacity-100 mt-10" : "grid-rows-[0fr] opacity-0 mt-0"
          }`}
        >
          <div className="overflow-hidden">
            <FooterGuide />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col gap-4">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
            {[
              { icon: "ri-line-fill", label: "LINE", href: "http://lin.ee/8c9qzq8" },
              { icon: "ri-instagram-line", label: "Instagram", href: "https://www.instagram.com/anet__parking/" },
              { icon: "ri-twitter-x-line", label: "X", href: "https://x.com/Anet_parking" },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="underline underline-offset-4 text-background-50 hover:text-secondary-200 whitespace-nowrap cursor-pointer"
              >
                <i className={`${s.icon} mr-1`} />
                {s.label}
              </a>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-xs text-background-300 text-center sm:text-left">
              © 2026 Anet Parking . All rights reserved.
            </div>
            <Link
              to="/?kanri=1"
              className="text-xs text-background-300 hover:text-background-50 underline-offset-4 hover:underline transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shield-keyhole-line mr-1" />
              管理者用
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}